var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWishlistIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 1.2,
  y: 0.5,
  width: 31.8,
  height: 31,
  rx: 15.5,
  fill: "#F2F0EC"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 1.2,
  y: 0.5,
  width: 31.8,
  height: 31,
  rx: 15.5,
  stroke: "#F2F0EC"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.1 11.656c1.155-1.314 3.293-1.85 5.025-.702a3.466 3.466 0 0 1 1.535 2.731c.086 2.476-2.165 4.46-5.608 7.498l-.073.064a1.337 1.337 0 0 1-1.764.006l-.066-.057-.04-.035c-3.421-3.024-5.66-5.003-5.569-7.47a3.468 3.468 0 0 1 1.535-2.737c1.732-1.155 3.87-.612 5.025.702Zm0 8.653.066-.064c3.122-2.75 5.182-4.569 5.182-6.413 0-1.276-.984-2.233-2.296-2.233-1.01 0-1.994.632-2.335 1.506H16.49c-.348-.874-1.331-1.506-2.342-1.506-1.312 0-2.296.957-2.296 2.233 0 1.844 2.06 3.663 5.183 6.413l.065.064Z",
  fill: "#00546F"
})));
export default SvgWishlistIcon;